import { Descriptions } from 'antd';
import React from 'react';

import { Gacha } from '@/api-client/generated/models';
import '@/Gacha/styles/gachaInfoDescriptions.css';

type Props = {
  gacha: Gacha;
};
const GachaInfoDescriptionsAggregatedData: React.FC<Props> = ({ gacha }) => (
  <Descriptions title="集計情報" column={1} bordered>
    <Descriptions.Item label="ガチャ回転数">{gacha.gachaCount ?? 0}</Descriptions.Item>
    <Descriptions.Item label="iOS メールリンククリック数">{gacha.iosDownloadCount ?? 0}</Descriptions.Item>
    <Descriptions.Item label="Android メールリンククリック数">{gacha.androidDownloadCount ?? 0}</Descriptions.Item>
  </Descriptions>
);

export default GachaInfoDescriptionsAggregatedData;
